/**
 * Helper function to ensure that `exclusiveId` is never combined with any other ID.
 * If the result array includes `exclusiveId`, it is guaranteed to be the *only* ID.
 */
export function resolveExclusiveIdSelection(
  exclusiveId: string,
  oldIds: string[],
  newIds: string[]
): string[] {
  const prevHadExclusive = oldIds.includes(exclusiveId);
  const nowHasExclusive = newIds.includes(exclusiveId);

  if (nowHasExclusive && !prevHadExclusive) {
    // User just selected the exclusive option — clear everything else
    return [exclusiveId];
  }
  if (nowHasExclusive && prevHadExclusive && newIds.length > 1) {
    // User selected a specific option while exclusive was selected — remove exclusive
    return newIds.filter(v => v !== exclusiveId);
  }
  return newIds;
}
